import React, { useEffect, useState } from 'react';
import { Flex, Text, Button, Icon } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FaGhost } from 'react-icons/fa';
import { track } from '../utils/umami';

function BouncingGhostIcon() {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    let startTime = null;
    let rafId;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      // Adjust the numbers below to control speed & amplitude
      const y = Math.sin(progress / 300) * 10;
      setOffset(y);

      rafId = requestAnimationFrame(animate);
    };

    rafId = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(rafId);
  }, []);

  return (
    <Icon
      as={FaGhost}
      boxSize={20}
      color="yellow.400"
      mb={4}
      mt={-6}
      // We apply the vertical “bounce” here
      style={{ transform: `translateY(${offset}px)` }}
    />
  );
}

function PageNotFound() {
  useEffect(() => {
    track.pageNotFound({ tipo: 'pagina' });
  }, []);

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      textAlign="center"
      minH="500px"
      borderRadius="md"
      bg="blue.50"
      px={4}
      mt={4}
      mr={4}
      ml={4}
    >
      <BouncingGhostIcon />
      <Text fontSize="xl" mb={6} mt={6}>
        Oops! La pagina che stai cercando si è persa tra i fantasmi.
      </Text>
      <Button as={Link} to="/" colorScheme="yellow" variant="solid" size="lg">
        Torna alla Home
      </Button>
    </Flex>
  );
}

export default PageNotFound;
